import slice from '../reducer/slice';
const { resetSelectedPlace } = slice.actions;

type TOperation = () => void;

const operation: TOperation = () => resetSelectedPlace();

export default operation;
